import { assertNever } from "@impero-com/common/utils/obj";
import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

import { ControlResultLinkType } from "api/generated/model";

/** The two link types the user-level pending-activities pages render. */
export type DisplayLinkType = Exclude<ControlResultLinkType, "both">;

const DIRECT_CONTROL_RESULT_TABLE_STATE_STORAGE_KEY =
    "userDirectControlResultList";
const GROUP_CONTROL_RESULT_TABLE_STATE_STORAGE_KEY =
    "userGroupControlResultList";

export function controlResultTableStorageKey(linkType: DisplayLinkType) {
    switch (linkType) {
        case "direct":
            return DIRECT_CONTROL_RESULT_TABLE_STATE_STORAGE_KEY;
        case "pool":
            return GROUP_CONTROL_RESULT_TABLE_STATE_STORAGE_KEY;
        default:
            assertNever(linkType);
    }
}

export const CONTROL_RESULT_LIST_COLUMN_IDS = {
    ACTIVITY: "activity",
    CONTROL_PROGRAM: "controlProgram",
    DUE_DATE: "dueDate",
    POOL: "pool", // only for pool variant
    CLAIMANT: "claimant", // only for pool variant
    ASSIGNED_AS: "assignedAs",
    TAGS: "tags",
} as const;

export const controlResultListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: CONTROL_RESULT_LIST_COLUMN_IDS.ACTIVITY,
                desc: false,
            },
        ],
    };

export const controlResultListColumnFiltersCodecMap = {
    [CONTROL_RESULT_LIST_COLUMN_IDS.ACTIVITY]: withModeCodec(encodedArrayCodec),
    [CONTROL_RESULT_LIST_COLUMN_IDS.CONTROL_PROGRAM]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_RESULT_LIST_COLUMN_IDS.POOL]: withModeCodec(encodedArrayCodec),
    [CONTROL_RESULT_LIST_COLUMN_IDS.CLAIMANT]: withModeCodec(encodedArrayCodec),
    [CONTROL_RESULT_LIST_COLUMN_IDS.ASSIGNED_AS]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_RESULT_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
};
